var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHot = function SvgHot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5747"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.08 2.986a21 21 0 0 0-1.976 2.108 27.3 27.3 0 0 0-3.493-3.908c-3.454 3.205-5.906 7.381-5.906 9.9a7.99 7.99 0 0 0 7.875 8.1 7.99 7.99 0 0 0 7.875-8.1c0-1.873-1.827-5.735-4.375-8.1m-.684 11.976a4.72 4.72 0 0 1-2.715.849 4.33 4.33 0 0 1-4.6-4.4c0-1.357.855-2.553 2.559-4.6.244.281 3.474 4.406 3.474 4.406l2.061-2.351q.218.363.4.7a4.19 4.19 0 0 1-1.179 5.396",
    "data-name": "Path 806"
  }))));
};
export default SvgHot;